import type { CurrencyInfo } from '@src/domains/coupons/types/coupon';

export const getDiscountCurrencyInfo = (fullPrice: CurrencyInfo, finalPrice: CurrencyInfo): CurrencyInfo => ({
  amountCents: fullPrice.amountCents - finalPrice.amountCents,
  currency: fullPrice.currency,
  originalAmountCents: fullPrice.originalAmountCents - finalPrice.originalAmountCents,
  originalCurrency: fullPrice.originalCurrency,
});
